import { formatJsonDataset as fjd } from '../../components/renderers';

const crudActions = {
  add: 'Add',
  edit: 'Edit',
  del: 'Delete',
  delete: 'Delete',
  view: 'View',
};

const crudPanels = {
  add: 'simple',
  edit: 'simple',
  delete: 'dialog',
  view: 'simple',
};

export const customerconfig = {
  approvalrequest: {
    service: {
      name: 'approvalrequest',
      title: 'Approval Requests',
      num: true,
      pageMode: 'remote',
      fields: [
        'rid','rix','rqn','cui','cuc','cun','rti','rtn','rtc','ref',
        'rbi','rbu','rbn','rqd','ati','atu','atn','asi','asn','asc',
        'fin','app','dbi','dbu','dbn','dcdt','rrs','dcn','rdt','dcd',
        'exi','sts','ast','stp',
      ],
      params: {
        rqn: 'Request No.',
        cui: 'Customer',
        rti: 'Request Type',
        rbi: 'Requested By',
        ati: 'Assigned To',
        asi: 'Approval Status',
        dbi: 'Decision By',
        dtf: 'Start Date',
        dtt: 'End Date',
        sts: 'Status',
        ast: 'Active Status',
      },
      grid: [
        ['rqn','Request No.'],
        ['cun','Customer'],
        ['rtn','Request Type'],
        ['rbn','Requested By'],
        ['rqd','Requested Date'],
        ['atn','Assigned To'],
        ['asn','Approval Status'],
        ['dbn','Decision By'],
        ['dcdt','Decision Date'],
        ['sts','Status'],
        ['stp','Stamp'],
      ],
      menu: {
        mnu: [
          { t:'Request No.', v:'rqn' },
          { t:'Customer', v:'cun' },
          { t:'Request Type', v:'rtn' },
          { t:'Approval Status', v:'asn' },
        ],
        def: 'rqn',
      },
      eform: [
        { id:'rqn', label:'Request No.', type:'tf', req:1, ops:{} },
        { id:'cui', label:'Customer', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'customer' } },
        { id:'rti', label:'Request Type', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'requesttype' } },
        { id:'ref', label:'Reference ID (auto-generated if blank)', type:'nf', req:0, ops:{} },
        { id:'rbi', label:'Requested By', type:'fa', req:1, ops:{}, off:['add','edit','delete'], cp:{ t:'bcs', s:'requesteduser' } },
        { id:'rqd', label:'Requested Date', type:'df', req:1, ops:{}, off:['add','edit','delete'] },
        { id:'ati', label:'Assigned To', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'assigneduser' } },
        { id:'asi', label:'Approval Status', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'approvalstatus' } },
        { id:'dbi', label:'Decision By', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'decisionuser' } },
        { id:'dcdt', label:'Decision Date', type:'df', req:0, ops:{} },
        { id:'rrs', label:'Request Reason', type:'ta', req:0, ops:{} },
        { id:'dcn', label:'Decision Notes', type:'ta', req:0, ops:{} },
        { id:'rdt', label:'Request Data', type:'jf', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:1, ops:{}, cp:{ t:'lcs', s:'status' } },
      ],
    },
    create: true,
    actions: crudActions,
    panels: crudPanels,
    formatters: { grid: { rdt: fjd, exi: fjd } },
  },

  customer: {
    service: {
      name: 'customer',
      title: 'Customers',
      num: false,
      pageMode: 'remote',
      fields: [
        'rid','rix','cuc','cun','cti','ctn','ctc','cci','ccn','ccc',
        'pho','aph','eml','pad','poa','cty','coi','coy','coc','tin',
        'reg','asi','asn','asc','nts','dcd','exi','sts','ast','stp',
      ],
      grid: [
        ['cuc','Customer No.'],
        ['cun','Customer Name'],
        ['ctn','Type'],
        ['ccn','Category'],
        ['pho','Phone'],
        ['eml','Email'],
        ['cty','City'],
        ['coy','Country'],
        ['asn','Account Status'],
        ['sts','Status'],
        ['stp','Stamp'],
      ],
      menu: {
        mnu: [
          { t:'Customer No.', v:'cuc' },
          { t:'Customer Name', v:'cun' },
          { t:'Phone', v:'pho' },
          { t:'Email', v:'eml' },
        ],
        def: 'cun',
      },
      eform: [
        { id:'cuc', label:'Customer No.', type:'tf', req:1, ops:{} },
        { id:'cun', label:'Customer Name', type:'tf', req:1, ops:{} },
        { id:'cti', label:'Customer Type', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'customertype' } },
        { id:'cci', label:'Customer Category', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'customercategory' } },
        { id:'pho', label:'Phone', type:'tf', req:0, ops:{} },
        { id:'aph', label:'Alternate Phone', type:'tf', req:0, ops:{} },
        { id:'eml', label:'Email', type:'tf', req:0, ops:{} },
        { id:'pad', label:'Physical Address', type:'ta', req:0, ops:{} },
        { id:'poa', label:'Postal Address', type:'ta', req:0, ops:{} },
        { id:'cty', label:'City', type:'tf', req:0, ops:{} },
        { id:'coi', label:'Country', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'country' } },
        { id:'tin', label:'Tax Identification No.', type:'tf', req:0, ops:{} },
        { id:'reg', label:'Registration No.', type:'tf', req:0, ops:{} },
        { id:'asi', label:'Account Status', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'customerstatus' } },
        { id:'nts', label:'Notes', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:1, ops:{}, cp:{ t:'lcs', s:'status' } },
      ],
    },
    create: true,
    actions: crudActions,
    panels: crudPanels,
    formatters: { grid: { exi: fjd } },
  },

  customercontact: {
    service: {
      name: 'customercontact',
      title: 'Customer Contacts',
      num: true,
      pageMode: 'remote',
      fields: [
        'rid','rix','cui','cuc','cun','ctn','jbt','pph','aph','eml',
        'ipr','nts','dcd','exi','sts','ast','stp',
      ],
      grid: [
        ['cun','Customer'],
        ['ctn','Contact Name'],
        ['jbt','Job Title'],
        ['pph','Primary Phone'],
        ['aph','Alternate Phone'],
        ['eml','Email'],
        ['ipr','Primary'],
        ['sts','Status'],
        ['stp','Stamp'],
      ],
      menu: {
        mnu: [
          { t:'Customer', v:'cun' },
          { t:'Contact Name', v:'ctn' },
          { t:'Phone', v:'pph' },
          { t:'Email', v:'eml' },
        ],
        def: 'ctn',
      },
      eform: [
        { id:'cui', label:'Customer', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'customer' } },
        { id:'ctn', label:'Contact Name', type:'tf', req:1, ops:{} },
        { id:'jbt', label:'Job Title', type:'tf', req:0, ops:{} },
        { id:'pph', label:'Primary Phone', type:'tf', req:0, ops:{} },
        { id:'aph', label:'Alternate Phone', type:'tf', req:0, ops:{} },
        { id:'eml', label:'Email Address', type:'tf', req:0, ops:{} },
        { id:'ipr', label:'Primary Contact', type:'fa', req:1, ops:{}, cp:{ t:'lcs', s:'truthy' } },
        { id:'nts', label:'Notes', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:1, ops:{}, cp:{ t:'lcs', s:'status' } },
      ],
    },
    create: true,
    actions: crudActions,
    panels: crudPanels,
    formatters: { grid: { exi: fjd } },
  },

  customercredit: {
    service: {
      name: 'customercredit',
      title: 'Customer Credit',
      num: true,
      pageMode: 'remote',
      fields: [
        'rid','rix','cui','cuc','cun','cel','clm','cdy','efd','exd',
        'abi','abu','abn','apd','ari','arn','asi','asn','asc','nts',
        'dcd','exi','sts','ast','stp',
      ],
      grid: [
        ['cun','Customer'],
        ['cel','Eligible'],
        ['clm','Credit Limit'],
        ['cdy','Credit Days'],
        ['efd','Effective Date'],
        ['exd','Expiry Date'],
        ['asn','Approval Status'],
        ['sts','Status'],
        ['stp','Stamp'],
      ],
      menu: {
        mnu: [
          { t:'Customer', v:'cun' },
          { t:'Approval Status', v:'asn' },
        ],
        def: 'cun',
      },
      eform: [
        { id:'cui', label:'Customer', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'customer' } },
        { id:'cel', label:'Credit Eligible', type:'fa', req:1, ops:{}, cp:{ t:'lcs', s:'truthy' } },
        { id:'clm', label:'Credit Limit', type:'nf', req:1, ops:{} },
        { id:'cdy', label:'Credit Days', type:'nf', req:1, ops:{} },
        { id:'efd', label:'Effective Date', type:'df', req:1, ops:{} },
        { id:'exd', label:'Expiry Date', type:'df', req:0, ops:{} },
        { id:'abi', label:'Approved By', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'user' } },
        { id:'apd', label:'Approved Date', type:'df', req:0, ops:{} },
        { id:'ari', label:'Approval Request', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'approvalrequest' } },
        { id:'asi', label:'Approval Status', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'approvalstatus' } },
        { id:'nts', label:'Notes', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:1, ops:{}, cp:{ t:'lcs', s:'status' } },
      ],
    },
    create: true,
    actions: crudActions,
    panels: crudPanels,
    formatters: { grid: { exi: fjd } },
  },

  customerpricelist: {
    service: {
      name: 'customerpricelist',
      title: 'Customer Price Lists',
      num: true,
      pageMode: 'remote',
      fields: [
        'rid','rix','cui','cuc','cun','pli','pln','plc','efd','exd',
        'idf','nts','dcd','exi','sts','ast','stp',
      ],
      grid: [
        ['cun','Customer'],
        ['pln','Price List'],
        ['efd','Effective Date'],
        ['exd','Expiry Date'],
        ['idf','Default'],
        ['sts','Status'],
        ['stp','Stamp'],
      ],
      menu: {
        mnu: [
          { t:'Customer', v:'cun' },
          { t:'Price List', v:'pln' },
        ],
        def: 'cun',
      },
      eform: [
        { id:'cui', label:'Customer', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'customer' } },
        { id:'pli', label:'Price List', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'pricelist' } },
        { id:'efd', label:'Effective Date', type:'df', req:1, ops:{} },
        { id:'exd', label:'Expiry Date', type:'df', req:0, ops:{} },
        { id:'idf', label:'Default Price List', type:'fa', req:1, ops:{}, cp:{ t:'lcs', s:'truthy' } },
        { id:'nts', label:'Notes', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:1, ops:{}, cp:{ t:'lcs', s:'status' } },
      ],
    },
    create: true,
    actions: crudActions,
    panels: crudPanels,
    formatters: { grid: { exi: fjd } },
  },

  customerdiscount: {
    service: {
      name: 'customerdiscount',
      title: 'Customer Discounts',
      num: true,
      pageMode: 'remote',
      fields: [
        'rid','rix','cui','cuc','cun','dci','dcn','dcc','dsp','mdp',
        'efd','exd','abi','abu','abn','apd','ari','arn','asi','asn',
        'asc','nts','dcd','exi','sts','ast','stp',
      ],
      grid: [
        ['cun','Customer'],
        ['dcn','Discount Category'],
        ['dsp','Discount %'],
        ['mdp','Maximum Discount %'],
        ['efd','Effective Date'],
        ['exd','Expiry Date'],
        ['asn','Approval Status'],
        ['sts','Status'],
        ['stp','Stamp'],
      ],
      menu: {
        mnu: [
          { t:'Customer', v:'cun' },
          { t:'Discount Category', v:'dcn' },
          { t:'Approval Status', v:'asn' },
        ],
        def: 'cun',
      },
      eform: [
        { id:'cui', label:'Customer', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'customer' } },
        { id:'dci', label:'Discount Category', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'discountcategory' } },
        { id:'dsp', label:'Discount Percent', type:'nf', req:1, ops:{} },
        { id:'mdp', label:'Maximum Discount Percent', type:'nf', req:0, ops:{} },
        { id:'efd', label:'Effective Date', type:'df', req:1, ops:{} },
        { id:'exd', label:'Expiry Date', type:'df', req:0, ops:{} },
        { id:'abi', label:'Approved By', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'user' } },
        { id:'apd', label:'Approved Date', type:'df', req:0, ops:{} },
        { id:'ari', label:'Approval Request', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'approvalrequest' } },
        { id:'asi', label:'Approval Status', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'approvalstatus' } },
        { id:'nts', label:'Notes', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:1, ops:{}, cp:{ t:'lcs', s:'status' } },
      ],
    },
    create: true,
    actions: crudActions,
    panels: crudPanels,
    formatters: { grid: { exi: fjd } },
  },

  customerstatement: {
    service: {
      name: 'customerstatement',
      title: 'Customer Statements',
      num: true,
      pageMode: 'remote',
      fields: [
        'rid','rix','etn','etd','ett','cui','cuc','cun','loi','lon',
        'loc','ivi','ivn','pyi','pyn','ref','dsc','cur','dbt','cdt',
        'net','rbl','pbi','pbu','pbn','pod','nts','dcd','exi','sts',
        'ast','stp','cri','crn',
      ],
      params: {
        cui:'Customer', cri:'Currency', dtf:'Date From', dtt:'Date To',
      },
      grid: [
        ['etd','Entry Date'],
        ['etn','Entry No.'],
        ['cun','Customer'],
        ['ett','Entry Type'],
        ['ref','Reference'],
        ['dsc','Description'],
        ['cur','Currency'],
        ['dbt','Debit'],
        ['cdt','Credit'],
        ['rbl','Running Balance'],
        ['lon','Location'],
      ],
      menu: {
        mnu: [
          { t:'Customer', v:'cun' },
          { t:'Entry No.', v:'etn' },
          { t:'Reference', v:'ref' },
        ],
        def: 'cun',
      },
      eform: [
        { id:'etd', label:'Entry Date', type:'df', req:0, ops:{} },
        { id:'etn', label:'Entry No.', type:'tf', req:0, ops:{} },
        { id:'cun', label:'Customer', type:'tf', req:0, ops:{} },
        { id:'ett', label:'Entry Type', type:'tf', req:0, ops:{} },
        { id:'ref', label:'Reference', type:'tf', req:0, ops:{} },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'cur', label:'Currency', type:'tf', req:0, ops:{} },
        { id:'dbt', label:'Debit', type:'nf', req:0, ops:{} },
        { id:'cdt', label:'Credit', type:'nf', req:0, ops:{} },
        { id:'rbl', label:'Running Balance', type:'nf', req:0, ops:{} },
        { id:'lon', label:'Location', type:'tf', req:0, ops:{} },
        { id:'ivn', label:'Invoice No.', type:'tf', req:0, ops:{} },
        { id:'pyn', label:'Payment No.', type:'tf', req:0, ops:{} },
        { id:'nts', label:'Notes', type:'ta', req:0, ops:{} },
      ],
    },
    create: false,
    actions: { view: 'View' },
    panels: { view: 'simple' },
    formatters: { grid: { exi: fjd } },
  },
};

export default customerconfig;
